import Vue from 'vue';
import './css/index.less'
import App from './App';
//引用富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
//引入富文本css
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { Loading } from 'element-ui';
//引用router.js
import router from './router/index.js'

Vue.config.productionTip = false;
Vue.prototype.$loading=Loading

import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';

Viewer.setDefaults({
  Options: {
    zIndex:8888,
    inline: true,
    button: true,
    navbar: true,
    title: true,
    toolbar: true,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
    transition: true,
    fullscreen: true,
    keyboard: true,
    url: 'data-source'
  }
});
Vue.use(Viewer);

//富文本编辑器添加实例
Vue.use(VueQuillEditor)
Vue.use(ElementUI,{ size: 'small', zIndex: 3000 });
new Vue({
  router,
  render: h => h(App),

}).$mount('#app');
